/*
 * @Author: wzc
 * @Date: 2024-06-29 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins 苏迪曼杯
 * @LastEditTime: 2024-06-29 19:11:02
 */

import bigSports_mixin from '@mixins/badminton/sudirman/bigSportsList_mixin.js'
export default {
  mixins: [bigSports_mixin],
  data() {
    return {
      containerFullClassName: 'containerFull_badminton_sudirman',
      defaultPath: ['badminton', 'sudirman', 'schedule'],
      axiosBaseUrl: '/badminton',
      sportCompetitionType: 'badminton_sudirman', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber】
      themeSeasonArr: [
        {
          sidArr: [
            '5042025',
            '5042023',
            '5042021',
            '5042019',
            '5042017',
            '5042015',
            '5042013',
            '5042011',
            '5042009',
            '5042007',
          ],
          themeIndex: 0,
        },
      ],
    }
  },
}
